module.exports = __webpack_public_path__ + "img/level_03.bf25306b.svg";